import * as React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon/index";
import styles from "./styles.scss";

interface Props {
  path?: string;
  children?: React.ReactNode;
  // 親側で独自のレイアウト/配置を持つ場合に、集約した上下マージンを無効化する
  disableSpacing?: boolean;
}

const handleClick = (e: any) => {
  e.preventDefault();
  history.back();
};

const renderLink = (props: Props) => {
  const { path } = props;

  if (path) {
    return (
      <Link to={path} className={styles.link}>
        <Icon name="icon-arrow-left" />
        <span className={styles.label}>{props.children}</span>
      </Link>
    );
  } else {
    return (
      <a className={styles.link} onClick={handleClick}>
        <Icon name="icon-arrow-left" />
        <span className={styles.label}>{props.children}</span>
      </a>
    );
  }
};

const BackLink = (props: Props) => {
  const className = props.disableSpacing
    ? `${styles.root} ${styles.noMargin}`
    : styles.root;
  return <div className={className}>{renderLink(props)}</div>;
};

export default BackLink;
